module.exports = function () { return '' }